import '../sass/citrus-featured-properties.scss';

(() => {
    const $citrusFeaturedProperties = document.querySelectorAll('.citrus-featured-properties');

    if (!$citrusFeaturedProperties) return;

    $citrusFeaturedProperties.forEach($citrusFeaturedProperty => {
        const $carousel = $citrusFeaturedProperty.querySelector('.citrus-featured-properties__carousel');
        const $paginationBars = $citrusFeaturedProperty.querySelectorAll('.citrus-featured-properties__pagination-bar');
        const $navigationNext = $citrusFeaturedProperty.querySelector('.citrus-featured-properties__navigation--next');
        const $navigationPrev = $citrusFeaturedProperty.querySelector('.citrus-featured-properties__navigation--prev');

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                keyboard: {
                    enabled: true,
                },
                loop: true,
                navigation: {
                    nextEl: $navigationNext ?? null,
                    prevEl: $navigationPrev ?? null,
                },
            });

            if ($paginationBars) {
                carousel.on('realIndexChange', swiper => {
                    $paginationBars.forEach(($paginationBar) => {
                        const index = parseInt($paginationBar.dataset.index);

                        if (swiper?.realIndex === index) {
                            $paginationBar.classList.add('citrus-pagination__bar--active');
                        }
                        
                        if (swiper?.realIndex !== index) {
                            $paginationBar.classList.remove('citrus-pagination__bar--active');
                        }
                    });
                });
            }
        };

        initCarousel();
    });
})();
